import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { routing } from '@utils/routing';
import React from 'react';
import { ConfirmBarView } from './ConfirmBarView';
export const ConfirmBarContainer = (props) => {
    const { currentShop } = useCurrentShop({ staleTime: Infinity });
    return (React.createElement(ConfirmBarView, { dashboardLogo: { name: currentShop?.name, to: routing.home.toString() }, ...props }));
};
